import React from 'react';
import { LayoutRoute } from 'components/Layout';
import { default as HomePublicaLayout } from 'components/Layout/HomePublica';
import PrivateLayoutRoute from 'components/Layout/PrivateLayoutRoute';
import NewTravelEmpresas from 'containers/TravelMex/NewTravelEmpresas';
import ContainerIngresoDatosTBTA from 'containers/TravelMex/ContainerIngresoDatosTBTA';
import ContainerRecuperarCotizacionTravelEmpresasResumen from 'containers/TravelMex/ContainerRecuperarCotizacionTravelEmpresa';
import ContainerCotizacionTravelEmpresasResumen from 'containers/TravelMex/ContainerTravelEmpresaResumen';
import ContainerFinalCompra from './ContainerFinalCompra';

const TBTA_ROUTES = [
  <LayoutRoute
    exact={true}
    path="/travel-empresas"
    loginRequired={true}
    layout={HomePublicaLayout}
    component={ContainerIngresoDatosTBTA}
  />,

  <LayoutRoute
    exact={true}
    path="/travel-empresas-planes"
    loginRequired={true}
    layout={HomePublicaLayout}
    component={NewTravelEmpresas}
  />,

  <LayoutRoute
    exact={true}
    path="/travel-empresas-resumen"
    loginRequired={true}
    layout={HomePublicaLayout}
    component={ContainerCotizacionTravelEmpresasResumen}
  />,

  <PrivateLayoutRoute
    exact={true}
    path="/travel-empresas-recuperar"
    loginRequired={true}
    layout={HomePublicaLayout}
    component={ContainerRecuperarCotizacionTravelEmpresasResumen}
  />,
  <LayoutRoute
    exact={true}
    path="/travel-empresas-final"
    loginRequired={true}
    layout={HomePublicaLayout}
    component={ContainerFinalCompra}
  />,
];

export default TBTA_ROUTES;
